module.exports = __webpack_public_path__ + "img/xiaoxi.8dfd1e99.png";